import { styled } from "@mui/material/styles";
import { Box, Slider, Typography } from "@mui/material";
import { colors } from "../../../theme/theme";

export const SliderContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  textAlign: "center",
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  color: colors.primary,
  fontWeight: "800",
  marginBottom: theme.spacing(1),
  textAlign: "left",
}));

export const LabelHint = styled(Typography)(({ theme }) => ({
  color: "rgba(73,42,24, 0.6)",
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  marginBottom: theme.spacing(2),
  textAlign: "left",
}));

export const MinMaxContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
});

export const MinMaxLabel = styled(Typography)({
  color: colors.primary,
  fontSize: "14px",
  fontWeight: "700",
});

export const StyledSlider = styled(Slider)(({ theme, value }) => ({
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(2),
  color: colors.primary,
  height: 8,
  "& .MuiSlider-thumb": {
    height: "50px",
    width: "50px",
    backgroundColor: colors.primary,
    color: "#fff",
    fontSize: "20px",
    fontWeight: "400",
    fontFamily: "'Quicksand', sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "4px solid #fff",
    boxShadow: "0 0 4px rgba(0,0,0,0.2)",
    "&::after": {
      paddingTop: 6,
      content: `"${value ?? 0}"`,
    },
    [theme.breakpoints.down("md")]: {
      height: "40px",
      width: "40px",
      fontSize: 18,
      "&::after": {
        paddingTop: 8,
      },
    },
    [theme.breakpoints.down("sm")]: {
      height: "30px",
      width: "30px",
      fontSize: 14,
      "&::after": {
        paddingTop: 11,
      },
    },
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: "transparent",
    border: "1px solid rgba(73,42,24, 0.2)",
  },
  "& .MuiSlider-track": {
    border: "none",
  },
}));
